import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addLocationData,
  deleteLocationListData,
  fetchLocations,
  updateLocationData,
} from "../../apis/locations";

export const fetchLocationListData = createAsyncThunk(
  "locationList/fetchLocationList",
  async (_, { rejectWithValue }) => {
    try {
      const locationList = await fetchLocations();
      return locationList;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.location.isLocationsDataFetched; // Adjust path based on your state structure
    },
  }
);

export const updateLocationListData = createAsyncThunk(
  "locationList/updateLocationData",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        locationId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      await updateLocationData(id, data);
      return { success: true, data };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const deleteLocationData = createAsyncThunk(
  "locationList/deleteLocationData",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteLocationListData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewLocationData = createAsyncThunk(
  "locationList/addLocation",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addLocationData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
